import Queue from "nq-js";

class UpdateObjectUseCase {
  execute(collection, document, options) {
    return new Queue.Document().update(collection, document, options);
  }
}

export default UpdateObjectUseCase;
